import { CreateImplementerProfile } from "../../../../gql/mutations";
import { ImplementerProfile } from "../../../../types";
import { client } from "../../../../gql/apollo";
import { GetAccount } from "../../../../gql/queries";

interface Args {
  implementerAccountUid: string;
  data: Partial<ImplementerProfile>;
}

export const createImplementerProfile = async (args: Args) => {
  const { implementerAccountUid = "" } = args;

  const result = await client.mutate({
    mutation: CreateImplementerProfile,
    variables: {
      ...args.data,
      implementerAccountUid
    },
    awaitRefetchQueries: true,
    refetchQueries: [{
      query: GetAccount,
      variables: { uid: implementerAccountUid }
    }]
  });
  return result;
};
